/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, March 30th 2024, 12:16:16 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Paper from "@mui/material/Paper";

type LibraryItemContainerProps = Pick<React.HtmlHTMLAttributes<HTMLDivElement>, "onClick" | "children">;

export const LibraryItemContainer = ({ onClick, children }: LibraryItemContainerProps) => (
  <Paper
    variant="outlined"
    className="center-container"
    sx={{
      background: "radial-gradient(circle at 18.7% 37.8%, rgb(250, 250, 250) 0%, rgb(225, 234, 238, 40%) 90%)",
      cursor: onClick ? "pointer" : null,
      height: "250px",
    }}
    onClick={onClick}
  >
    <div>{children}</div>
  </Paper>
);
